import script from "./DetailProfil.vue?vue&type=script&setup=true&lang=ts"
export * from "./DetailProfil.vue?vue&type=script&setup=true&lang=ts"

import "./DetailProfil.vue?vue&type=style&index=0&id=ff8fc32a&lang=sass&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ff8fc32a"]])

export default __exports__